var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9401 9.86661C12.8442 10.4372 13.0062 11.0207 13.383 11.4621C13.7598 11.9036 14.3133 12.1582 14.8964 12.1585L19.0227 12.1602C19.6679 12.1605 20.1412 12.7622 19.9847 13.3832L18.4966 19.2863C18.3861 19.7244 17.9893 20.0317 17.5341 20.0317H7.95259V12.8489L10.834 9.27605C11.5376 8.40354 11.921 7.31944 11.921 6.20208V5.06533C12.9116 5.52549 13.4904 6.59093 13.3068 7.68388L12.9401 9.86661ZM6.76207 11.1743L9.28459 8.04646C9.70678 7.52295 9.93679 6.8725 9.93679 6.20208V4.76779C9.93679 3.56209 11.1275 2.71073 12.2806 3.092C14.3588 3.77918 15.6241 5.86399 15.264 8.00747L14.8973 10.1902L19.0235 10.1919C20.9594 10.1928 22.3793 11.9977 21.9096 13.8607L20.4215 19.7638C20.0902 21.0781 18.8998 22 17.5341 22H7.95259H4.97629C3.33253 22 2 20.6781 2 19.0475V14.1268C2 12.4962 3.33253 11.1743 4.97629 11.1743H6.76207ZM5.96839 13.1426H4.97629C4.42837 13.1426 3.9842 13.5833 3.9842 14.1268V19.0475C3.9842 19.5911 4.42837 20.0317 4.97629 20.0317H5.96839V13.1426Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/thumbs-up-icon.8dddba320e696944761dd95416bc4216.svg";
export { ForwardRef as ReactComponent };